import * as React from "react"

export type RegistrationFormVariants = "registrationForm" | "interestsForm"

export interface RegistrationFormContextValue {
	setActiveFormVariant: React.Dispatch<
		React.SetStateAction<RegistrationFormVariants>
	>
	activeFormVariant: RegistrationFormVariants
}

export const RegistrationFormContext =
	React.createContext<RegistrationFormContextValue>({
		setActiveFormVariant: (formVariant: RegistrationFormVariants) => null,
		activeFormVariant: null,
	})

interface RegistrationFormContextProviderProps {
	defaultFormVariant: RegistrationFormVariants
	children?: React.ReactNode
}

export const RegistrationFormContextProvider: React.FC<RegistrationFormContextProviderProps> =
	(props) => {
		const [activeFormVariant, setActiveFormVariant] =
			React.useState<RegistrationFormVariants>(props.defaultFormVariant)
		return (
			<RegistrationFormContext.Provider
				value={{
					setActiveFormVariant,
					activeFormVariant,
				}}
			>
				{props.children}
			</RegistrationFormContext.Provider>
		)
	}
